/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ base: NonNullable<unknown>, months: NonNullable<unknown>, rate: NonNullable<unknown> }} Admin_Billing_Batch_Detail_MonthsInputs */

const es_admin_billing_batch_detail_months = /** @type {(inputs: Admin_Billing_Batch_Detail_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base} × ${i?.months} meses (-${i?.rate}%)`)
};

const en_admin_billing_batch_detail_months = /** @type {(inputs: Admin_Billing_Batch_Detail_MonthsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base} × ${i?.months} months (-${i?.rate}%)`)
};

/**
* | output |
* | --- |
* | "Base: {base} × {months} months (-{rate}%)" |
*
* @param {Admin_Billing_Batch_Detail_MonthsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_detail_months = /** @type {((inputs: Admin_Billing_Batch_Detail_MonthsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Detail_MonthsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_detail_months(inputs)
	return en_admin_billing_batch_detail_months(inputs)
});
export { admin_billing_batch_detail_months as "admin.billing.batch.detail_months" }